import { render, staticRenderFns } from "./consumptionBill.vue?vue&type=template&id=0c806a98&scoped=true"
import script from "./consumptionBill.vue?vue&type=script&lang=js"
export * from "./consumptionBill.vue?vue&type=script&lang=js"
import style0 from "./consumptionBill.vue?vue&type=style&index=0&id=0c806a98&prod&lang=scss&scoped=true"
import style1 from "./consumptionBill.vue?vue&type=style&index=1&id=0c806a98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c806a98",
  null
  
)

export default component.exports